import { Suspense, lazy } from "react";

import type { FC } from "react";

export interface SurveyAlertWizardDialogContentProps {
  open: boolean;
  onClose: () => void;
}

const LazySurveyAlertWizardDialogContent = lazy(() =>
  import("../schedule/components/survey-alert-wizard-dialog").then((module) => ({
    default: module.SurveyAlertWizardDialogContent,
  })),
);

export const SurveyAlertWizardDialogContentSlot: FC<SurveyAlertWizardDialogContentProps> = (
  props,
) => (
  <Suspense fallback={null}>
    <LazySurveyAlertWizardDialogContent {...props} />
  </Suspense>
);
